
import customAxios from "config";
import { globalJson } from "global/global_json";
import { renterError } from "utils/errorMessage";

export const getCompanyInfoFun = async (): Promise<any> => {
  try {
    const response = await customAxios.get("/api/company/configurations/", {
      params: {
        company_id: globalJson.company_id,
      },
    });
    return response.data;
  } catch (error) {
    return { error: renterError(error, "company") };
  }
};
export const getCompanyID = async (): Promise<any> => {
  try {
    // The tenant is resolved per-request from the request's own domain, so one
    // build serves every operator. A commented-out `company_id = 24` override
    // used to sit here for local testing — removed, because uncommenting it
    // pins every tenant site to one company and the failure is silent.
    const response = await customAxios.get("/api/company/get-website-id/");
    globalJson.company_id = response?.data?.company_id;
    return {
      company_id: response?.data?.company_id,
    };
  } catch (error) {
    return { error: renterError(error, "company") };
  }
};

export const getWebInfo = async (): Promise<any> => {
  try {
    const response = await customAxios.get(`api/website/details/`, {
      params: {
        company_id: globalJson.company_id,
      },
    });
    return response.data;
  } catch (error) {
    return { error: renterError(error, "company") };
  }
};

export const getWebsiteSectionInfo = async (): Promise<any> => {
  try {
    const response = await customAxios.get(`api/website/sections/`, {
      params: {
        company_id: globalJson.company_id,
      },
    });
    return response.data;
  } catch (error) {
    return { error: renterError(error, "company") };
  }
};
